// extracted by mini-css-extract-plugin
export default {"bottom-bar":"BottomBar_bottom-bar__3t_yC"};